import React, { Component, PropTypes } from 'react';
import EventTeamName from './EventTeamName';
import { Icon } from 'react-fast-ui';
import _ from 'underscore';

export default class EventTeamNameWithFollowedTeams extends Component {
  static propTypes = {
    followedTeams: PropTypes.array,
    team: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  };

  static defaultProps = {
    followedTeams: [],
    team: null
  };

  render() {
    const { className, followedTeams, team } = this.props;

    const isFollowed = _.any(followedTeams, followed => followed.team.id === team.id);

    return (
      <span className={className}>
        <EventTeamName team={team}/>
        {
          isFollowed ? (
              <span className="mg-left-xs">
                <Icon key="fi" name="bookmark" className="color-success"/>
              </span>
            ) : null
        }
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventTeamNameWithFollowedTeams.jsx